import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import config from 'SRC/config/config.json'

export const AddPhoneBtn = ({ onClick }) => {
  const { t } = useTranslation('common')

  return (
    <a className='dodaj-model-btn' href='javascript:void(0)' onClick={onClick}>
      <span className='add-model'>[+]</span> {t('Dodaj broj telefona')}
    </a>
  )
}

AddPhoneBtn.propTypes = {
  onClick: PropTypes.func.isRequired
}
